import {
  Checkbox as MuiCheckbox,
  FormControlLabel as MuiFormControlLabel,
} from '@mui/material';
import Accordion from 'components/Accordion';
import LoadingPage from 'components/LoadingPage';
import { Search } from 'components/ui';
import colors from 'lib/colors';
import { mergeAndSortArrays } from 'lib/utils/returnUniqueIdValues';
import useGetPatientGroupsForAutocomplete from 'pagesAdmin/SettingsPage/TabPatientGroups/hooks/useGetPatientGroupsForAutocomplete';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

export default function PatientGroupFilter({ filters, setFilters, defaultExpanded = false }) {
  const { t } = useTranslation();
  const careTeams = useSelector((state) => state.user.user.careTeams);

  const {
    patientGroups,
    loadMore,
    loading,
    setSearch,
  } = useGetPatientGroupsForAutocomplete({
    filter: {}, // BE returns only patient groups that are  assigned to same care teams as user by default without filters
  });

  const listContainerRef = useRef(null);

  useEffect(() => {
    const handleScroll = (event) => {
      const { scrollTop, scrollHeight, clientHeight } = event.currentTarget;
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        loadMore();
      }
    };

    const listDiv = listContainerRef.current;
    if (listDiv) {
      listDiv.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (listDiv) {
        listDiv.removeEventListener('scroll', handleScroll);
      }
    };
  }, [loadMore]);

  const handleCheckboxClick = (patientGroup) => {
    const isPresent = !!filters.patientGroupIds?.find(
      (item) => patientGroup.id === item.id
    );

    const updatedConditionsList = isPresent
      ? filters.patientGroupIds?.filter((item) => patientGroup.id !== item.id)
      : [...filters.patientGroupIds, patientGroup];
    setFilters((curr) => ({
      ...curr,
      patientGroupIds: updatedConditionsList,
    }));
  };

  return (
    <Accordion title={t('Patient groups')} defaultExpanded={defaultExpanded}>
      <Search
        small
        placeholder={t('Search')}
        onChange={(e, v) => setSearch(e.target.value)}
      />

      <div
        ref={listContainerRef}
        style={{
          display: 'flex',
          flexDirection: 'column',
          padding: 10,
          margin: '10px 0',
          border: `1px solid ${colors.gray200}`,
          borderRadius: 6,
          maxHeight: '450px',
          overflowY: 'auto',
          gap: 10,
        }}
      >
        {loading ? (
          <LoadingPage style={{ width: 100, height: 100 }} />
        ) : patientGroups?.length === 0 ? (
          t('No patient groups')
        ) : (
          mergeAndSortArrays(filters.patientGroupIds, patientGroups || [], 'id')?.map?.((patientGroup) => {
            return (
              <MuiFormControlLabel
                key={patientGroup.id}
                control={
                  <MuiCheckbox
                    checked={
                      !!filters.patientGroupIds.find(
                        (item) => item.id === patientGroup.id
                      )
                    }
                    onClick={() => handleCheckboxClick(patientGroup)}
                  />
                }
                label={patientGroup.title}
              />
            );
          })
        )}
      </div>
    </Accordion>
  );
}
